import { Box, Button, Flex, Heading, HStack, Icon, IconButton, Image, SimpleGrid, Span, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion';
import { LuArrowRight, LuArrowUpRight, LuHandHeart, LuHeadset, LuLaptopMinimalCheck, LuTicket } from 'react-icons/lu'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { href, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HashLink } from 'react-router-hash-link';

const OurService = () => {

    const {t} = useTranslation();
    let isIOSDevice = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent); // fails on iPad iOS 13
    const arrayOfServices = [
        {
            brand: t('feature1Title'),
            icon: <LuHandHeart strokeWidth={'1px'} />,
            image: require('../../../assets/services/3.png'),
            href: '/services/voting',
            description: t('feature1Description')
        },
        {
            brand: t('feature2Title'),
            icon: <LuTicket strokeWidth={'1px'} />,
            image: require('../../../assets/services/2.png'),
            href: '/services/tiketing',
            description: t('feature2Description')
        },
        {
            brand: t('feature3Title'),
            icon: <LuLaptopMinimalCheck strokeWidth={'1px'} />,
            image: require('../../../assets/services/4.png'),
            href: '/services/coding',
            description: t('feature3Description')
        },
        {
            brand: t('feature4Title'),
            icon: <LuHeadset strokeWidth={'1px'} />,
            image: require('../../../assets/services/1.png'),
            href: '#',
            description: t('feature4Description')
        },

    ];


    const MotionBox = motion.create(Box)
    const MotionHeading = motion.create(Heading)
    const MotionText = motion.create(Text)
    const MotionSpan = motion.create(Span)
    const MotionImage = motion.create(Image)
    const gradient1 = useColorModeValue('blue.50', 'gray.900')
    const gradient2 = useColorModeValue('purple.50', 'gray.900')
    const textGhost = useColorModeValue('gray.800', 'gray.500')
    const iconColor = useColorModeValue('blue.600', 'blue.500')
    const navigate = useNavigate()





    return (
        <Flex
            px={{ md: '10%', '2xl': "19%", base: 4 }}
            py={{'2xl' :40, base: 24}}
            overflow={'hidden'}
            position={'relative'}
            id="our-services"
        >
            <Box w={'full'}>

                <MotionHeading
                    fontFamily={'Outfit'}
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5 }}
                    textTransform={'uppercase'}
                    viewport={{ once: true }}
                    fontSize={{ '2xl': 'xl', md: 'xl', base: 'md' }}
                >
                    {t('featureSubtitle')}
                </MotionHeading>
                <Flex mt={{'2xl': 10, base: 4}} gap={4} w={'full'} justify={'space-between'} flexDir={{md: 'row', base: 'column'}}>
                    <MotionHeading
                        maxW={{'2xl': '690px', base: '320px'}}
                        fontFamily={'Poppins'}
                        fontSize={{ '2xl': '7xl', md: '3xl', base: '2xl' }}
                        fontWeight={600}
                        lineHeight={1.1}
                        letterSpacing={-1.8}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        {t('featureTitle').split(" ").slice(0, -3).join(' ')}
                        <MotionSpan
                            pl={{'2xl': 4, base: 2}}
                            color={'red.600'}
                            bgGradient={'to-r'}
                            gradientFrom={'blue.500'}
                            fontFamily={'Onest'}
                            gradientTo={'purple.600'}
                            bgClip={'text'}
                            animate={{ backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"] }}
                            transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                            bgSize="200% auto"
                        >
                        {t('featureTitle').split(' ').slice(-3).join(' ')}
                        </MotionSpan>
                    </MotionHeading>


                    <Box maxW={'500px'}>
                        <MotionText
                            fontSize={{'2xl': 'xl', md: 'lg', base: 'md'}}
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            viewport={{ once: true }}
                        >
                            {t('featureDescription')}
                        </MotionText>

                        <HStack mt={8} flexWrap={{'2xl': 'unset', base: 'wrap'}} gap={4}>
                            <HashLink smooth to="#our-services">
                                <Button fontFamily={'Momo Trust Display'} fontWeight={ isIOSDevice ? 'medium' : 'normal'} size={{'2xl': 'lg',md: 'md', base: 'md'}} rounded={'full'} colorPalette={'purple'} variant={'surface'}>
                                    {t('callToActionFeature')}
                                    <Icon>
                                        <LuArrowRight />
                                    </Icon>
                                </Button>
                            </HashLink>
                            <HashLink smooth to="#our-location">
                                <Button fontFamily={'Momo Trust Display'} fontWeight={ isIOSDevice ? 'medium' : 'normal'} size={{'2xl': 'lg',md: 'md', base: 'md'}} rounded={'full'} colorPalette={'purple'} variant={'surface'}>
                                    {t('callToActionFeature2')}
                                    <Icon>
                                        <LuArrowRight />
                                    </Icon>
                                </Button>
                            </HashLink>
                        </HStack>
                    </Box>
                </Flex>






                <SimpleGrid mt={20} columns={{'2xl': 4, md: 3, base: 1}} gap={8} w={'full'} placeItems={'center'}>

                    {arrayOfServices.map((elt, index) =>
                        <MotionBox
                            key={index}
                            position={'relative'}
                            initial={{ opacity: 0, rotateY: 90 }}
                            whileInView={{ opacity: 1, rotateY: 0 }}
                            transition={{ duration: 0.8, delay: index * 0.2, type: "spring", stiffness: 100 }}
                            viewport={{ once: true }}
                            whileHover={{ y: -15, transition: { duration: 0.3 } }}
                            style={{ perspective: 1000 }}
                        >
                            <MotionBox
                                position={'relative'}
                                overflow={'hidden'}
                                className="group inverted-radius"
                                w={{'2xl': '350px', md: '300px', base: '320px'}}
                                h={'500px'}
                                bgGradient={'to-tl'}
                                gradientFrom={gradient1}
                                gradientTo={gradient2}
                                p={8}
                                pt={10}
                                transition={{
                                    y: { duration: 3 + index, repeat: Infinity, ease: "easeInOut" },
                                    default: { duration: 0.3 }
                                }}
                                animate={{ y: [0, -10, 0] }}
                                whileHover={{
                                    scale: 1.02,
                                    rotate: 1,
                                    boxShadow: "2xl",
                                    gradientFrom: "blue.200",
                                    gradientTo: "purple.200",
                                    transition: { duration: 0.2 }
                                }}
                            >
                                <MotionBox
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ delay: (index * 0.2) + 0.4, duration: 0.5 }}
                                >
                                    <Icon boxSize={10} color={iconColor}>
                                        {elt.icon}
                                    </Icon>
                                </MotionBox>

                                <MotionHeading
                                    mt={8}
                                    fontFamily={'Momo Trust Display'} fontWeight={ isIOSDevice ? 'medium': 'normal'}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ delay: (index * 0.2) + 0.5, duration: 0.5 }}
                                >
                                    {elt.brand}
                                </MotionHeading>
                                <MotionText
                                    mt={3}
                                    color={textGhost}
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    lineClamp={{'2xl': 'inherit', md: 6, base: 7}}
                                    transition={{ delay: (index * 0.2) + 0.6, duration: 0.5 }}
                                >
                                    {elt.description}
                                </MotionText>
                            </MotionBox>
                            <IconButton onClick={()=>navigate(`/${elt.href}`)} colorPalette={'blue'} variant={'surface'} position={'absolute'} bottom={{'2xl' : 4, base: 6}} right={{'2xl' : 5, base: 7}} rounded={'full'} size={{'2xl' :'xl',  base: 'lg'}}>
                                <LuArrowUpRight />
                            </IconButton>

                        </MotionBox>
                    )}
                </SimpleGrid>
            </Box>



            <MotionImage
                w={{ '2xl': '800px', base: '500px'}}
                opacity={useColorModeValue(0.5, 0.8)}
                position={'absolute'}
                right={'-15%'}
                bottom={10}
                zIndex={-1}
                src={require('../../../assets/vector/1.png')}
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: useColorModeValue(0.5, 0.8), x: 0 }}
                animate={{ y: [0, -30, 0], rotate: [0, -5, 0] }}
                transition={{
                    duration: 1,
                    y: { duration: 4, repeat: Infinity, ease: "easeInOut" },
                    rotate: { duration: 8, repeat: Infinity, ease: "easeInOut" }
                }}
            />

            <MotionImage
                w={{ '2xl': '400px', base: '150px'}}
                opacity={useColorModeValue(0.5, 0.8)}
                top={{'2xl': 5, base: 3}}
                position={'absolute'}
                left={{ '2xl': '-3%', base: '80%'}}
                zIndex={-1}
                src={require('../../../assets/vector/1.png')}
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: useColorModeValue(0.5, 0.8), x: 0 }}
                transition={{
                    duration: 1,
                    y: { duration: 5, repeat: Infinity, ease: "easeInOut" },
                    rotate: { duration: 8, repeat: Infinity, ease: "easeInOut" }
                }}
            />




        </Flex>
    )
}

export default OurService